import React, { Component } from "react";
import { Form, Input } from "semantic-ui-react";
import _ from "lodash";
import InlineError from "../../messages/InlineError";

class RangeControl extends Component {
  componentDidMount() {
    this.initializeStateValues(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.initializeStateValues(nextProps);
  }

  onChange = (e, data) => {
    const values = this.state.values;
    values[data.name] = data.value;
    if (this.props.notifyChangeToForm !== undefined)
      this.props.notifyChangeToForm(e, { name: data.name, value: data.value });
  };

  initializeStateValues = props => {
    const values = {};
    _.forEach(props.controls, control => {
      if (props.defaultFormData[control.FieldName] !== undefined) {
        values[control.FieldName] = props.defaultFormData[control.FieldName];
      } else {
        values[control.FieldName] = "";
      }
    });
    this.setState({ values });
  };

  render() {
    const { controls } = this.props;
    const items = [];
    let errors = "";
    _.forEach(controls, (control, index) => {
      const color = control.FieldRequired ? "red" : "black";
      items.push(
        <label
          key={`age_label_${control.FieldLabel}_${index}`}
          htmlFor={control.FieldLabel}
          style={{ color }}
        >
          {control.FieldLabel}
        </label>
      );
      items.push(
        <Input
          key={`age_txt_${control.FieldLabel}_${index}`}
          id={control.FieldId}
          type="text"
          name={control.FieldName}
          placeholder={control.FieldLabel}
          onChange={this.onChange}
          value={this.state !== null && this.state.values[control.FieldName]}
          size={"tiny"}
        />
      );
      if (
        this.props.errors[control.FieldName] !== undefined &&
        this.props.errors[control.FieldName] !== ""
      ) {
        errors = `${errors} this.props.errors[control.FieldName]`;
      }
    });
    return (
      <Form.Field error={errors !== ""}>
        {items}
        {errors !== "" && <InlineError text={errors} />}
      </Form.Field>
    );
  }
}

export default RangeControl;



// WEBPACK FOOTER //
// ./src/components/forms/controls/RangeControl.js